import echarts from 'echarts'
import moment from 'moment'
function generateData() {
    return {
        title: [
            {
              left: 'center',
              text: '博主粉丝历史数'
            },
         
          ],
        tooltip: {
            formatter: function(target) {
                return `${target.name}：<br />${target.data}`
            },
            trigger: 'item',
            show: true,
        },
        xAxis: {
            type: 'category',
            data: []
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              data: [],
              type: 'bar',
              barWidth:20,
            }
          ]
    };
}

export default {
    data() {
        this.echarts = null
        this.arr = null
        return {
            dis: false,
        }
    },
    mounted() {
        
      //   this.echarts = echarts.init(this.$refs.echarts, 'walden')
      window.addEventListener("resize", this.windowResize);
    },
    ddestroyed() {
        window.removeEventListener(this.windowResize)
    },
    methods: {
        windowResize() {
            if (this.timer) {
                clearTimeout(this.timer)
              }
              this.timer = setTimeout(() => {
                this.timer = null
                this.$nextTick(() => {
                    if (this.echarts && this.arr) {
                        this.echarts.resize()
                    }
                
                })
              }, 500)
        },
        display(arr) {
            if (!arr.length) {
                return 
            }
            this.arr = arr
            this.dis = true
            setTimeout(() => {
                this.update(arr)
            }, 200)
        },
        update(arr) {
            arr = arr.map(item => {
                return {
                    ...item,
                    updated_at: moment(item.updated_at).format('YYYY-MM-DD')
                }
            })
       
            this.echarts = echarts.init(this.$refs.echarts, 'walden')
          
            const params = generateData()
            params.xAxis.data = arr.map(i => i.updated_at)
            params.series[0].data = arr.map(i => i.amount)
            this.echarts.setOption(params)
        }
   
    },
    render() {
        return <div>
            <div style={{
                height:'300px',
                display: this.dis ? 'block' : 'none'
        }} ref="echarts"/>
        </div>
    }
}